import { Component, OnInit } from '@angular/core'
import { CategoryModel } from '../../models/category.model'
import { SettingsService } from '../../services/settings.service'
import { Observable } from 'rxjs'
import { Setting } from '../../models/setting.model'
import { NotificationService } from '../../../../services/notification.service'
import { JmlTitleService } from '../../../../services/jml-title.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'jml-lib-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  userSettingsOnly: boolean

  categories: CategoryModel[]
  categories$: Observable<CategoryModel[]>
  activeEditSetting: string
  orgSettingValue: string

  constructor(
    private route: ActivatedRoute,
    private settingService: SettingsService,
    private notificationService: NotificationService,
    private titleService: JmlTitleService
  ) {}

  ngOnInit() {
    this.userSettingsOnly = this.route.snapshot.data['userSettingsOnly']
    this.titleService.setAppTitle(this.getTitle())
    this.categories = []
    this.loadSettings()
    this.activeEditSetting = null
  }

  getTitle() {
    return this.userSettingsOnly ? 'Benutzer-Einstellungen' : 'System-Einstellungen'
  }

  loadSettings() {
    if (this.userSettingsOnly) {
      this.categories$ = this.settingService.getUserSettings()
    } else {
      this.categories$ = this.settingService.getSystemSettings()
    }
  }

  saveSetting(setting: Setting) {
    let result: Observable<boolean>
    if (this.userSettingsOnly) {
      result = this.settingService.setUserSetting(setting.name, setting.value)
    } else {
      result = this.settingService.setSystemSetting(setting.name, setting.value)
    }
    result.subscribe((result) => {
      if (result) {
        this.activeEditSetting = null
        this.loadSettings()
      }
    })
  }

  setActiveForEdit(setting: Setting) {
    this.orgSettingValue = setting.value
    this.activeEditSetting = setting.name
  }

  setToDefault(setting: Setting) {
    setting.value = setting.defaultValue
  }

  cancelEdit(setting: Setting) {
    this.activeEditSetting = null
    setting.value = this.orgSettingValue
    this.orgSettingValue = null
  }

  pingNextcloud() {
    this.settingService.ping().subscribe(() => {
      this.notificationService.addSuccessNotification('Ping erfolgreich.')
    })
  }
}
